(function () {
  // Delegate clicks so buttons inserted by cart section rendering work immediately.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-box-btn]');
    if (!btn || btn.disabled) return;
    var container = btn.closest('[data-packaging-upsell]');
    if (!container) return;
    var errorEl = container.querySelector('[data-box-error]');
    var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';

    function setLoading(isLoading) {
      btn.disabled = isLoading;
      var textEl = btn.querySelector('.packaging-box-upsell__btn-text');
      var spinner = btn.querySelector('.packaging-box-upsell__spinner');
      if (spinner) spinner.hidden = !isLoading;
      if (textEl) textEl.style.opacity = isLoading ? '0.4' : '1';
    }

    function resolveVariantId(callback) {
      var variantId = btn.dataset.variantId || container.dataset.variantId;
      if (variantId && variantId !== 'null' && variantId !== '') {
        callback(parseInt(variantId, 10));
        return;
      }

      // Dynamically fetch product by handle if not preloaded in Liquid
      var handle = container.dataset.handle || 'packaging-box';
      fetch(routeRoot + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          if (product && product.variants && product.variants.length) {
            var variant = product.variants.find(function (v) { return v.available; });
            if (!variant) { callback(null); return; }
            var vId = variant.id;
            btn.dataset.variantId = vId;
            container.dataset.variantId = vId;
            callback(vId);
          } else {
            callback(null);
          }
        })
        .catch(function () {
          callback(null);
        });
    }

    function updateCartBadges() {
      fetch(routeRoot + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cartData) {
          var countBubbles = document.querySelectorAll('.cart-count-bubble span');
          countBubbles.forEach(function (el) { el.textContent = cartData.item_count; });

          var cartBubble = document.getElementById('cart-icon-bubble');
          if (cartBubble) {
            if (cartData.item_count > 0) cartBubble.classList.remove('is-empty');
            else cartBubble.classList.add('is-empty');
          }

          // Update subtotal text if present
          var totals = document.querySelectorAll('.totals__total-value, .cart__subtotal-value');
          totals.forEach(function (totalEl) {
            if (typeof cartData.total_price === 'number') {
              totalEl.textContent = (cartData.total_price / 100).toLocaleString('en-IN', { style: 'currency', currency: cartData.currency });
            }
          });

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'packaging-upsell', cartData: cartData });
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {});
    }

      e.preventDefault();
      if (errorEl) errorEl.hidden = true;

      var isAdded = btn.classList.contains('is-added');

      setLoading(true);

      resolveVariantId(function (variantId) {
        if (!variantId) {
          setLoading(false);
          if (errorEl) {
            errorEl.textContent = 'The selected packaging box is unavailable. Please check its availability in Shopify.';
            errorEl.hidden = false;
          }
          return;
        }

        if (isAdded) {
          // REMOVE FROM CART
          fetch(routeRoot + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: btn.dataset.itemKey || String(variantId), quantity: 0 })
          })
            .then(function (r) {
              return r.json().then(function (data) {
                if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not remove packaging box');
                return data;
              });
            })
            .then(function () {
              setLoading(false);
              btn.classList.remove('is-added');
              container.classList.remove('is-in-cart');
              btn.dataset.itemKey = '';
              btn.querySelector('.packaging-box-upsell__btn-text').innerHTML = '+ Add';
              updateCartBadges();
            })
            .catch(function (err) {
              setLoading(false);
              if (errorEl) {
                errorEl.textContent = err.message || 'Could not remove packaging box. Please try again.';
                errorEl.hidden = false;
              }
            });
        } else {
          // ADD TO CART
          fetch(routeRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
            .then(function (r) {
              return r.json().then(function (data) {
                if (!r.ok || data.status) {
                  throw new Error(data.description || data.message || 'Could not add to cart');
                }
                return data;
              });
            })
            .then(function (data) {
              setLoading(false);
              btn.classList.add('is-added');
              container.classList.add('is-in-cart');
              if (data.items && data.items[0]) btn.dataset.itemKey = data.items[0].key;
              btn.querySelector('.packaging-box-upsell__btn-text').innerHTML = '✓ Added <span class="packaging-box-upsell__remove">(Remove)</span>';
              updateCartBadges();
            })
            .catch(function (err) {
              setLoading(false);
              if (errorEl) {
                errorEl.textContent = err.message || 'Could not add packaging box.';
                errorEl.hidden = false;
              }
            });
        }
      });
  });
})();
